<ods-ui-modal
  [focusOnShow]="true"
  [header]="headerText()"
  [(isVisible)]="isVisible"
>
  @if (isLoading()) {
    <ods-loader class="ods-spinner-medium" />
  } @else {
    <ods-modal-single-select
      class="w-full"
      [isTenantSelection]="true"
    />
    @if (requireDeployment()) {
      @if (!this.deploymentStore.deploymentIsLoading()) {
        <ods-modal-single-select
          class="w-full"
          [isTenantSelection]="false"
          [disabled]="!this.deploymentStore.selectedTenant()"
        />
        @if(!this.deploymentStore.selectedTenant()){
          <p-message class="mt-5 mb-5" severity="warn">
            Select a tenant before selecting a deployment.
          </p-message>
        }
      } @else {
        <ods-loader class="ods-spinner-medium" />
      }
    }
  }

  <div class="mt-5 mb-3 w-full">
  <button
    class="bg-brand text-white border-0"
    pButton
    type="button"
    [raised]="true"
    [text]="true"
    [disabled]="!this.deploymentStore.selectedTenant()"
    (click)="reloadData()"
  >
    <ods-ui-icon icon="ion:refresh-outline"/>
    Reload deployments
  </button>
  <button
    class="bg-brand text-white ml-2"
    pButton
    type="button"
    [raised]="true"
    [text]="true"
    (click)="isVisible.set(false)"
  >
    <ods-ui-icon icon="ion:close-outline"/>
    Close
  </button>
  </div>
</ods-ui-modal>
